<template>
    <mu-card>
      <mu-card-text>
        <div class="v-header">{{$t('message.labelTodaysPrediction')}} <mu-icon value="help"></mu-icon></div>
        <div>{{$t('message.labelTodaysPredictionExplain')}}</div>
      </mu-card-text>
      <mu-card-text>
        <mu-row gutter>
          <mu-col width="50" desktop="50" tablet="50" class="center-text">
            <radial-progress
              mode="outOf"
              data-id="radial-loading-1"
              :value="$store.state.cards.activity.steps.steps"
              :outOfValue="$store.state.cards.activity.steps.predictions.steps"
              suffix=""
              color="#0179d5"
            ></radial-progress>
            <div>{{$t('message.labelSteps')[0].toUpperCase()+$t('message.labelSteps').substr(1)}}</div>
          </mu-col>
          <mu-col  width="50" desktop="50" tablet="50" class="center-text">
            <radial-progress
              mode="outOf"
              data-id="radial-loading-3"
              :value="$store.state.cards.activity.steps.calories"
              :outOfValue="$store.state.cards.activity.steps.predictions.calories"
              suffix=""
              color="#89C93B"
            ></radial-progress>
            <div>{{$t('message.nutrientCalories')}}</div>
          </mu-col>
        </mu-row>
      </mu-card-text>
    </mu-card>
</template>

<script>
    import RadialProgress from "../../../RadialProgress/RadialProgress";
    export default {
      components: {RadialProgress},
      name: "activity-wearable-visualisation"
    }
</script>

<style>
  .center-text {
    text-align: center;
  }
  .v-header {
    font-size: 18px;
    margin-bottom: 8px;
  }
  .v-header i.mu-icon.material-icons {
    float: right;
    color: orange;
  }
</style>



// WEBPACK FOOTER //
// WearableVisualisation.vue?5a356c44